/*
 * search-normalize.js — West Blue
 *
 * Collapses known punctuation/case/language variants of a few series titles to
 * one canonical query string, applied at SEARCH SUBMIT time (Enter / search
 * button) on every search form. This does NOT touch as-you-type predictive
 * suggestions and creates no inventory — it only unifies the term that reaches
 * the results page and analytics, so repeated reformulations of the same series
 * (e.g. "Dr. Stone" / "dr stone" / "DR STONE", or "よふかしのうた" and its
 * English name) collapse to a single content-gap signal instead of several.
 *
 * The map is intentionally tiny and only fires on a WHOLE-QUERY match, so
 * longer queries like "dr stone vol 1" pass through untouched.
 *
 * HOU-522 (weekly improvement experience-search-dr-stone-aliases).
 */
(function () {
  // Canonical targets match the store's own product titles/series tags
  // ("Dr Stone", "Call of the Night").
  var ALIASES = {
    'dr stone': 'Dr Stone',
    'drstone': 'Dr Stone',
    'doctor stone': 'Dr Stone',
    'よふかしのうた': 'Call of the Night',
    'yofukashi no uta': 'Call of the Night',
    'yofukashi': 'Call of the Night',
    'call of the night': 'Call of the Night',
  };

  // Lowercase and collapse every run of non-letter/non-number characters
  // (periods, spaces, hyphens, full-width space) to a single ASCII space.
  // \p{L} keeps Japanese kana/kanji intact so よふかしのうた maps as one key.
  function normKey(s) {
    try {
      return s.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    } catch (e) {
      // Older engines without Unicode property escapes: fall back to a
      // whitespace/punctuation collapse that still handles the ASCII variants.
      return s.toLowerCase().replace(/[\s._\-]+/g, ' ').trim();
    }
  }

  function canonical(raw) {
    var t = (raw == null ? '' : String(raw)).trim();
    if (!t) return raw;
    var key = normKey(t);
    return Object.prototype.hasOwnProperty.call(ALIASES, key) ? ALIASES[key] : raw;
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    var input = form.querySelector('input[name="q"]') || form.querySelector('input[type="search"]');
    if (!input) return;
    var next = canonical(input.value);
    if (next !== input.value) input.value = next;
  }

  function bind() {
    var forms = document.querySelectorAll('form[role="search"], form[action*="/search"]');
    forms.forEach(function (form) {
      if (form.dataset.wbNormalizeBound) return;
      form.dataset.wbNormalizeBound = '1';
      // useCapture=true so the value is rewritten before the predictive-search
      // component's own submit handler reads/serialises it.
      form.addEventListener('submit', onSubmit, true);
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);

  // Expose the mapper so other scripts can reuse it if ever needed.
  window.WBSearchNormalize = canonical;
})();
